module.exports = __webpack_public_path__ + "img/logo-dark.e2e19ab1.png";